import { FaAngleDoubleDown, FaCertificate, FaChalkboardTeacher, FaEnvelope, FaPhone, FaQuoteRight, FaSchool } from 'react-icons/fa';
import image3 from '../assets/image3.jpg';
import image4 from '../assets/image4.webp';
import image7 from '../assets/image7.jpg';
import image8 from '../assets/image8.webp';
import image9 from '../assets/image9.jpeg';
import image10 from '../assets/image10.jpg';
import image11 from '../assets/image11.jpg';
import image12 from '../assets/image12.jpg';
import image13 from '../assets/image13.jpg';
import image14 from '../assets/image14.png';
import image15 from '../assets/image15.jpg';
import image16 from '../assets/image16.jpg';
import image17 from '../assets/genericpicF.webp';
import image18 from '../assets/genericpicM.jpg';
import image19 from '../assets/tagore.webp';


export const navLinks = [
    {
        id: 'Home',
        link: '',
    },
    {
        id: 'About',
        link: 'about',
    },
   /* {
        id: 'Facilities',
        link: 'facility',
    },*/
    {
        id: 'Programs',
        link: 'programs',
    },
    {
        id: 'Contact Us',
        link: 'contact'
    },
    {
        id: 'Admission',
        link: 'apply',
    },
];

export const missionVision = [
    {
        id: 1,
        title: 'Our Vision',
        text: 'At Little Sanctum, Our vision is to inspire a generation of confident, capable, and compassionate learners who embrace their individuality and contribute meaningfully to the world. Through the Montessori approach, we envision a nurturing community where children develop a lifelong love of learning, a deep respect for themselves and others, and the skills to thrive in an ever-changing world. We aim to empower each child to grow with curiosity, creativity, and purpose.',
        icon: <FaAngleDoubleDown />,
    },
    {
        id: 2,
        title: 'Our Mission',
        text: 'At Little Sanctum, we are dedicated to nurturing each child natural curiosity, independence, and love of learning. Rooted in the Montessori philosophy, we provide a thoughtfully prepared environment that encourages exploration, creativity, and respect. Our mission is to guide children toward becoming confident, compassionate, and self-motivated individuals who are prepared for a lifetime of discovery and growth.',
        icon: <FaAngleDoubleDown />,
    },
];

export const whySchool = [
    {
        id: 1,
        title: 'Confidence Through Independence',
        reason: "Montessori encourages children to make choices, solve problems, and care for themselves and their environment. This builds genuine self-confidence, responsibility, and a strong sense of belief",
        icon: <FaSchool />,
    },
    {
        id: 2,
        title: 'Personalized Learning Pace',
        reason: "Every child learns differently—and Montessori meets them where they are. Instead of forcing a one-size-fits-all approach, the method allows children to explore concepts deeply, at their own rhythm, leading to more meaningful and lasting understanding.",
        icon: <FaCertificate />,
    },
    {
        id: 3,
        title: 'Respect and Social Growth',
        reason: "In Montessori classrooms, children learn to collaborate, resolve conflicts peacefully, and respect differences. This nurturing environment helps shape compassionate, socially aware individuals from the very beginning.",
        icon: <FaChalkboardTeacher />,
    },
];

export const testimonials = [
    {
        id: 1,
        icon: <FaQuoteRight />,
        image: image3,
        name: 'Dr. Maria Montessori',
        testimonial: "The goal of early childhood education should be to activate the child's own natural desire to learn",
    },
    {
        id: 2,
        icon: <FaQuoteRight />,
        image: image4,
        name: 'Jeff Bezos (Amazon founder)',
        testimonial: "I learned from Montessori that it's not about pouring knowledge into a child, but about allowing that child to learn at their own pace, through their own experience.",
    },
    {
        id: 3,
        icon: <FaQuoteRight />,
        image: image19,
        name: 'Rabindranath Tagore',
        testimonial: 'The Montessori system is a wonderful step in the right direction... It is a scientific method for educating the child in freedom and with respect.',
    },
    {
        id: 4,
        icon: <FaQuoteRight />,
        image: image17,
        name: 'Larry Page (Google Co-founder)',
        testimonial: "I went to Montessori school, where they taught me to be curious and to take initiative. That's how I approach problem-solving today.",
    },
    {
        id: 5,
        icon: <FaQuoteRight />,
        image: image18,
        name: 'Sergey Brin (Google Co-founder)',
        testimonial: "I think it was part of that training… of being self-motivated, questioning what's going on in the world, doing things a little bit differently. I do think that's a big part of where our products came from.",
    },
    {
        id: 6,
        icon: <FaQuoteRight />,
        image: image18,
        name: 'Jimmy Wales, Founder of Wikipedia',
        testimonial: "I think the philosophy of Montessori... is very much in line with Wikipedia, in terms of fostering curiosity and self-motivation. He has credited his Montessori background with encouraging a love of learning, independent thinking, and curiosity—all qualities that deeply influenced the creation of Wikipedia.",
    },
    {
        id: 7,
        icon: <FaQuoteRight />,
        image: image18,
        name: 'Vikram Sarabhai, Father of Indian space program',
        testimonial: "I think the philosophy of Montessori... is very much in line with Wikipedia, in terms of fostering curiosity and self-motivation. He has credited his Montessori background with encouraging a love of learning, independent thinking, and curiosity—all qualities that deeply influenced the creation of Wikipedia.",
    }
    
];

// export const footerLinks = [
//     {
//         id: 1,
//         link: "Home",
//     },
//     {
//         id: 2,
//         link: "About",
//     },
//     {
//         id: 3,
//         link: "Facility",
//     },
//     {
//         id: 4,
//         link: "Programs",
//     },
//     {
//         id: 5,
//         link: "Apply",
//     },
// ]

export const footerContact = [
    {
        id: 1,
        text: "Plot 323 Saibaba colony, Nallagandla - Tellapur Rd,",
    },
    {
        id: 2,
        text: "Fair Lands, Tellapur,",
    },
    {
        id: 3,
        text: "Hyderabad, Serilingampalle (M),",
    },
    {
        id: 4,
        text: "Telangana 500019",
    },
];

export const footerContactNum = [
    {
        id: 1,
        icon: <FaPhone />,
        text: "+91 76759 29396",
    },
    {
        id: 2,
        icon: <FaEnvelope />,
        text: "admin@littlesanctumpreschools.in",
    },
];

export const AboutPart = [
    {
        id: 1,
        image: image7,
        title: "Programs",
        text: "Our Toddler and Primary programs are created and led by AMI-certified educators with extensive experience in child development and Montessori pedagogy, designed to meet the unique developmental needs of children at each stage. After school program is thoughtfully designed for genuine need only, with limited seats to ensure personalized care and attention.",
    },
    {
        id: 2,
        image: image8,
        title: "Facilities",
        text: "Every element—from the carefully chosen materials to the peaceful layout of the classroom—is intentionally designed to foster independence, concentration, curiosity, and a deep love for learning. At Little Sanctum, we are committed to providing a nurturing, respectful, and enriching environment where every child can thrive at their own pace.",
    },
    {
        id: 3,
        image: image9,
        title: "Faculties",
        text: "At Little Sanctum, every adult who interacts with our children is AMI-certified, ensuring a deep understanding of Montessori principles and child development. We are committed to maintaining the highest standards by employing faculty who are not only professionally trained but also deeply dedicated to nurturing and guiding each child with care, respect, and Expertise.",
    },
];

export const facilities = [
    {
        id: 1,
        image: image8,
        title: "School Library",
        text: "Our extensive library and resource center serve as a hub of knowledge, providing a diverse collection of books, e-books, journals, and multimedia resources. It is a quiet oasis where students can immerse themselves in reading and research.",
    },
    {
        id: 2,
        image: image10,
        title: "Music Room",
        text: "We recognize the importance of nurturing students' passion for music. Our music facilities provide a vibrant and inspiring space for students to explore, create, and excel in the world of music.",
    },
    {
        id: 3,
        image: image11,
        title: "Sport Facility",
        text: "Our school offers a range of sports facilities, including a well-equipped gymnasium, playgrounds, and courts for various sports, encouraging students to stay active and develop a spirit of sportsmanship.",
    },
    {
        id: 4,
        image: image12,
        title: "Computer Lab",
        text: "We understand the pivotal role technology plays in modern education. Our computer lab facilities are designed to provide students with a cutting-edge learning environment that fosters digital literacy.",
    },
    {
        id: 5,
        image: image13,
        title: "Science Lab",
        text: "We take immense pride in providing our students with top-notch science lab facilities that are designed to ignite curiosity, foster exploration, and enhance scientific learning.",
    },
    {
        id: 6,
        image: image14,
        title: "Art Studio",
        text: "Creativity thrives in our art studios, where students can explore various mediums and unleash their artistic potential. These studios are designed to inspire young artists to express themselves through visual arts.",
    },
    {
        id: 7,
        image: image15,
        title: "Medicare",
        text: "The well-being of our students is of utmost importance. Our school provides a dedicated medical room and trained staff to attend to any health-related needs and emergencies.",
    },
    {
        id: 8,
        image: image16,
        title: "Multipurpose hall",
        text: "Our Multipurpose Hall is a hub of creativity, learning, and community engagement, providing numerous benefits and opportunities for our students, faculty, and the broader school community.",
    },
    {
        id: 9,
        image: image9,
        title: "Modern Classrooms",
        text: "Our school boasts spacious and well-equipped modern classrooms designed to create an optimal learning environment. Each classroom is thoughtfully arranged to enhance student engagement and foster a collaborative atmosphere.",
    },
];

export const MoreInfo = [
    {
        id: 1,
        title: "Housing",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio earum nemo ad at reiciendis natus consequatur numquam",
    },
    {
        id: 2,
        title: "Financial Aid",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio earum nemo ad at reiciendis natus consequatur numquam",
    },
    {
        id: 3,
        title: "Tuition",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio earum nemo ad at reiciendis natus consequatur numquam",
    },
    {
        id: 4,
        title: "Immigration",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio earum nemo ad at reiciendis natus consequatur numquam",
    },
]